<template>
  <div class="color-explainer" :class="{ 'color-explainer--bg' : bg }">
    <div class="color-explainer__item"><span class="color-explainer__item__color bg--valuered"></span> <span v-html="this.$Strings('valueColorRedExplainer')"></span></div>
    <div class="color-explainer__item"><span class="color-explainer__item__color bg--valueyellow"></span> <span v-html="this.$Strings('valueColorYellowExplainer')"></span></div>
    <div class="color-explainer__item"><span class="color-explainer__item__color bg--valuegreen"></span> <span v-html="this.$Strings('valueColorGreenExplainer')"></span></div>
  </div>
</template>

<script>
export default {
  name: 'high-medium-low-explainer',
  props: {
    bg: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';

  .color-explainer {
    color-adjust: exact;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    display: flex;
    flex-wrap: nowrap;
    font-size: 10px;
    width: 100%;

    &--bg {
      background: $gray-lightest;
      padding: 10px 20px;
    }

    &__item {
      flex: 0 0 auto;
      line-height: 1;
      margin-left: 20px;

      &:first-child{ margin-left: 0; }
      
      &__color {
        display: inline-block;
        height: 0.8em;
        margin-right: 3px;
        vertical-align: middle;
        width: 0.8em;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/misc/HighMediumLowExplainer.vue